/**
 * Shared Recharts theme: colors, tooltip styles, axis styles.
 * Used by all chart components for consistent appearance.
 */

export const CHART_COLORS = {
  primary: "#6366f1", // indigo-500
  secondary: "#8b5cf6", // violet-500
  success: "#22c55e", // green-500
  warning: "#f59e0b", // amber-500
  danger: "#ef4444", // red-500
  muted: "#6b7280", // gray-500

  // Quadrant colors for Market Map
  goldmine: "#22c55e",
  competitive: "#f59e0b",
  premium: "#6366f1",
  dead: "#ef4444",
} as const;

/** For bar charts with multiple categories */
export const PALETTE = [
  "#6366f1",
  "#8b5cf6",
  "#ec4899",
  "#f59e0b",
  "#22c55e",
  "#06b6d4",
  "#f97316",
  "#14b8a6",
];

export const TOOLTIP_STYLE = {
  contentStyle: {
    backgroundColor: "var(--bg-surface)",
    border: "1px solid var(--border)",
    borderRadius: "8px",
    fontSize: "13px",
  },
  labelStyle: { fontWeight: 600 },
} as const;

export const AXIS_STYLE = {
  fontSize: 12,
  fill: "var(--text-muted)",
} as const;
